import React, { useState } from 'react';
import {
    Box,
    Container,
    TextField
} from '@mui/material';
import { AppButton } from 'components/widgets/AppButton';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { AppHeroView } from 'components/utils/AppHeroView';
import { AppSectionView } from 'components/utils/AppSectionView';
import AppText from 'components/widgets/AppText';
import { useApp } from 'AppProvider';

const ContactUsPage = () => {
    const { sharedData} = useApp();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        company: '',
        message: '',
    });

    const contactInfo = [
        {
            icon: <LocationOnIcon fontSize="large" />,
            title: 'Our Location',
            description: sharedData.contact.address,
        },
        {
            icon: <PhoneIcon fontSize="large" />,
            title: 'Phone Numbers',
            description: sharedData.contact.phone,
        },
        {
            icon: <EmailIcon fontSize="large" />,
            title: 'Email Us',
            description: sharedData.contact.email,
        },
        {
            icon: <WhatsAppIcon fontSize="large" />,
            title: 'WhatsApp',
            description: sharedData.contact.phone,
        },
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form submitted:', formData);
    };

    const formFields = [
        { label: "Name", name: "name", value: formData.name, onChange: handleChange, fullWidth: true, required: true },
        { label: "Email", name: "email", type: "email", value: formData.email, onChange: handleChange, fullWidth: true, required: true },
        { label: "Phone", name: "phone", type: "tel", value: formData.phone, onChange: handleChange, fullWidth: true, required: true },
        { label: "Company", name: "company", value: formData.company, onChange: handleChange, fullWidth: true },
        { label: "Message", name: "message", value: formData.message, onChange: handleChange, multiline: true, rows: 4, fullWidth: true, required: true }
    ]

    return (
        <Box>
            {/* Hero Section */}
            <AppHeroView
                title="Contact Us"
                description="Get in touch with us for all your commercial vehicle transport needs."
            />

            {/* Contact Information Cards */}
            <AppSectionView items={contactInfo} />

            {/* Contact Form */}
            <Container maxWidth="md" sx={{ py: 8 }}>
                <AppText variant="h4" gutterBottom text="Send Us a Message" />
                <AppText variant="body1" color="text.secondary" gutterBottom text="Fill out the form below and we will get back to you as soon as possible." />
                <Box
                    component="form"
                    onSubmit={handleSubmit}
                    sx={{
                        mt: 4,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 3,
                    }}
                >
                    {formFields.map((field, index) => (
                        <TextField {...field} />
                    ))}
                    <Box sx={{ textAlign: 'center', mt: 2 }}>
                        <AppButton type="submit" variant="contained" color="primary">
                            Submit
                        </AppButton>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default ContactUsPage;